import { type NCWTokenCardProps } from '@capsicum/socios-core';

export const getChilizCardProps = (data: NCWTokenCardProps) => {
	return {
		formattedAltBalance: data.formattedAltBalance,
		formattedDefaultBalance: data.formattedDefaultBalance,
		testID: data.testID,
		title: 'Chiliz',
		usableFormattedAltBalance: data.usableFormattedAltBalance,
		usableFormattedDefaultBalance: data.usableFormattedDefaultBalance,
		usableTokenBalance: data.usableTokenBalance,
		variant: 'chiliz'
	} satisfies NCWTokenCardProps;
};
